import React from 'react';
import { FaThumbsUp, FaThumbsDown, FaRedo } from 'react-icons/fa';
import RichCards from './RichCards';
import { EduGenieAvatarImg } from './edugenieBrand';

const formatTime = (value) => {
  if (!value) return '';
  try {
    return new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch (error) {
    return '';
  }
};

const getUserInitials = (user) => {
  const first = user?.first_name?.[0] || user?.firstName?.[0] || '';
  const last = user?.last_name?.[0] || user?.lastName?.[0] || '';
  const initials = `${first}${last}`.toUpperCase();
  return initials || 'U';
};

const ChatMessage = ({
  message,
  user,
  onFeedback,
  onRetry
}) => {
  const isUser = message.role === 'user';
  const isError = message.is_error;
  const cards = message.payload?.cards || [];

  return (
    <div className={`edugenie-msg-row ${isUser ? 'is-user' : 'is-bot'}`}>
      <div
        className={`edugenie-avatar ${isUser ? 'is-user' : 'is-bot'}`}
        aria-hidden="true"
      >
        {isUser ? (
          getUserInitials(user)
        ) : (
          <EduGenieAvatarImg className="edugenie-brand-img" alt="" />
        )}
      </div>
      <div>
        <div className="edugenie-bubble">
          {message.text}
          {!isUser && cards.length > 0 ? <RichCards cards={cards} /> : null}
        </div>
        <div className="edugenie-meta">
          <span>{formatTime(message.timestamp)}</span>
          {!isUser && message.conversation_id && !isError ? (
            <div className="edugenie-feedback" role="group" aria-label="Rate this answer">
              <button
                type="button"
                className={message.feedback_rating === 1 ? 'is-active' : ''}
                onClick={() => onFeedback(message.conversation_id, 1)}
                aria-label="Mark answer as helpful"
                title="Helpful"
              >
                <FaThumbsUp size={12} />
              </button>
              <button
                type="button"
                className={message.feedback_rating === 0 ? 'is-active' : ''}
                onClick={() => onFeedback(message.conversation_id, 0)}
                aria-label="Mark answer as not helpful"
                title="Not helpful"
              >
                <FaThumbsDown size={12} />
              </button>
            </div>
          ) : null}
          {isError && message.retry_text ? (
            <button
              type="button"
              className="edugenie-retry-btn"
              onClick={() => onRetry(message.retry_text, message.retry_intent_code)}
              aria-label="Retry sending message"
            >
              <FaRedo className="me-1" size={10} /> Retry
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
